<template>
  <div v-if="dashboardDrilldownFilters != null && dashboardDrilldownFilters.length" class="mt-3">
    <div class="font-weight-bold text-charcoal mb-1">
      <template v-if="showFilterWarning">
        <icon class="exclamation-circle" :data-c-tooltip="`Predefined filter on list view may conflict with this data point. Check your list view's configurations.`"></icon>
      </template>
      Filtered by ({{ dashboardDrilldownFilters.length }}):
    </div>
    <pill
      v-for="filterObj in dashboardDrilldownFilters"
      :value="`${filterObj.filter_display}`"
      :key="filterObj.id"
      :data-c-tooltip="filterObj.property_display"
      color="Orange"
      @onRemove="remove(filterObj)">
    </pill>
  </div>
</template>

<script lang="ts">
  import Vue from "vue"
  import dashboardDrilldownFiltersMixin from '../../../formability/modelViews/mixins/dashboardDrilldownFiltersMixin'

  export default Vue.extend({
    mixins: [dashboardDrilldownFiltersMixin],
    props:{
    },
    computed: {
      showFilterWarning(): boolean {
        if (!this.selectedPublishedListView?.predefinedFilterRuleset) return false;
        const predefinedFilterPropertyClientIds = {};
        const predefinedFilterRules = this.selectedPublishedListView.predefinedFilterRuleset.conditional_rules;
        for (const rule in predefinedFilterRules) {
          const refControlId = predefinedFilterRules[rule].referenced_control_id;
          predefinedFilterPropertyClientIds[refControlId] = true;
        }
        const hasConflictingFilters = this.dashboardDrilldownFilters.some(f => predefinedFilterPropertyClientIds[f.property_client_id]);
        return hasConflictingFilters;
      },
    },
    methods: {
      remove(filterObj){
        const filterId = filterObj.id
        let query = Object.assign({}, this.$route.query);
        let filterQueryCount = Object.keys(query).filter((e) => {return e.startsWith("dashboard_drilldown")}).length
        if(filterQueryCount === 1){
          delete query[`drill_down`];
        }
        if (filterObj.is_conditional_rule_filter){
          delete query[`dashboard_drilldown_conditional_filter_${filterId.replace('-conditional', '')}`];
        }else{
          delete query[`dashboard_drilldown_filter_${filterId}`];
        }
        this.$router.replace({ query });
        this.$store.commit("dashboardDrillDownFiltersStore/removeDashboardDrilldownFilter", filterId)
      }
    },
  });
</script>